export class RelInstallParametreModel {
    idRelInstallParametre: number;
    idParametre: number;
    valeurParam: string;
    idInstall: string;
    modifieLe: string;

    constructor(_idRelInstallParametre: number, _idParametre: number, _valeurParam: string, _idInstall: string) {
        this.idRelInstallParametre = _idRelInstallParametre;
        this.idParametre = _idParametre;
        this.valeurParam = _valeurParam;
        this.idInstall = _idInstall;
        this.modifieLe = null;
    }
}
